import { axiosInstance } from '../../../common/http/axiosInstance'

export function unsubscribe(token: $TSFixMe) {
  return axiosInstance.put(`/v1/user/email/unsubscribe`, token)
}
